import { render, staticRenderFns } from "./drag-img.vue?vue&type=template&id=656e088d&scoped=true&"
import script from "./drag-img.vue?vue&type=script&lang=js&"
export * from "./drag-img.vue?vue&type=script&lang=js&"
import style0 from "./drag-img.vue?vue&type=style&index=0&id=656e088d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e088d",
  null
  
)

component.options.__file = "drag-img.vue"
export default component.exports